module.exports = __webpack_public_path__ + "static/media/choithramsLearnNewSkills.a22c9669.png";